__turbopack_context__.v({
  "active": "style-module-scss-module__xUnafa__active",
  "departmentTitle": "style-module-scss-module__xUnafa__departmentTitle",
  "description": "style-module-scss-module__xUnafa__description",
  "fadeIn": "style-module-scss-module__xUnafa__fadeIn",
  "item": "style-module-scss-module__xUnafa__item",
  "list": "style-module-scss-module__xUnafa__list",
  "photo": "style-module-scss-module__xUnafa__photo",
  "photoWrap": "style-module-scss-module__xUnafa__photoWrap",
  "role": "style-module-scss-module__xUnafa__role",
  "wrapper": "style-module-scss-module__xUnafa__wrapper",
});
